import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  SFLoadingScreen: {
    width: 'auto',
    background: theme.palette.text.white,
    height: theme.spacing(60.875),
    display: 'flex',
    justifyContent: 'center',
    margin: theme.spacing(5),
    gap: theme.spacing(4),
    borderRadius: theme.spacing(2),
    alignItems: 'center',
  },
}))
